export default "__VITE_ASSET__jIpu$MJQ__"